import * as reportsActions from '../actions/Reports';

const initialState = {
  summaryMonthlyData: {},
  summaryCumulativeData: {},
  summaryCustomData: {},
  summaryFilteredData: {},
  summaryGeneralData: {},
  gochiAmountPratformData: {
    gochiAmounts: []
  },
  gochiAmountTypeData: {
    gochiAmounts: []
  },
  gochiUserCountData: {
    gochiUserCounts: [
      {
        gochiDate: '2019/12/1',
        webCount: 4,
        appCount: 10
      },
      {
        gochiDate: '2019/12/2',
        webCount: 3,
        appCount: 12
      },
      {
        gochiDate: '2019/12/3',
        webCount: 4,
        appCount: 14
      },
      {
        gochiDate: '2019/12/4',
        webCount: 5,
        appCount: 16
      },
      {
        gochiDate: '2019/12/5',
        webCount: 3,
        appCount: 10
      },
      {
        gochiDate: '2019/12/6',
        webCount: 2,
        appCount: 12
      },
      {
        gochiDate: '2019/12/7',
        webCount: 3,
        appCount: 14
      },
      {
        gochiDate: '2019/12/8',
        webCount: 3,
        appCount: 16
      },
      {
        gochiDate: '2019/12/9',
        webCount: 2,
        appCount: 14
      },
      {
        gochiDate: '2019/12/10',
        webCount: 5,
        appCount: 10
      },
      {
        gochiDate: '2019/12/11',
        webCount: 3,
        appCount: 12
      },
      {
        gochiDate: '2019/12/12',
        webCount: 3,
        appCount: 13
      },
      {
        gochiDate: '2019/12/13',
        webCount: 2,
        appCount: 14
      },
      {
        gochiDate: '2019/12/14',
        webCount: 3,
        appCount: 16
      },
      {
        gochiDate: '2019/12/15',
        webCount: 2,
        appCount: 18
      },
      {
        gochiDate: '2019/12/16',
        webCount: 4,
        appCount: 15
      },
      {
        gochiDate: '2019/12/17',
        webCount: 3,
        appCount: 16
      },
      {
        gochiDate: '2019/12/18',
        webCount: 3,
        appCount: 12
      },
      {
        gochiDate: '2019/12/19',
        webCount: 5,
        appCount: 13
      },
      {
        gochiDate: '2019/12/20',
        webCount: 3,
        appCount: 14
      },
      {
        gochiDate: '2019/12/21',
        webCount: 5,
        appCount: 17
      },
      {
        gochiDate: '2019/12/22',
        webCount: 3,
        appCount: 10
      },
      {
        gochiDate: '2019/12/23',
        webCount: 3,
        appCount: 12
      },
      {
        gochiDate: '2019/12/24',
        webCount: 4,
        appCount: 14
      },
      {
        gochiDate: '2019/12/25',
        webCount: 3,
        appCount: 10
      },
      {
        gochiDate: '2019/12/26',
        webCount: 5,
        appCount: 15
      },
      {
        gochiDate: '2019/12/27',
        webCount: 3,
        appCount: 13
      },
      {
        gochiDate: '2019/12/28',
        webCount: 5,
        appCount: 11
      },
      {
        gochiDate: '2019/12/29',
        webCount: 4,
        appCount: 12
      },
      {
        gochiDate: '2019/12/30',
        webCount: 3,
        appCount: 14
      },
      {
        gochiDate: '2019/12/31',
        webCount: 5,
        appCount: 12
      }
    ]
  },
  gochiCountData: {
    gochiCounts: []
  },
  shopGochiAmountData: {
    shopGochiAmounts: []
  },
  shopGochiTableData: {
    list: [],
    count: 0
  },
  error: false,
  status: 200,
  error_message: ''
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case reportsActions.GET_REPORT_SUMMARY_MONTHLY_SUCCESS:
      return Object.assign({}, state, { summaryMonthlyData: action.payload });
    case reportsActions.GET_REPORT_SUMMARY_MONTHLY_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_GENERAL_REPORT_SUMMARY_SUCCESS:
      return Object.assign({}, state, { summaryGeneralData: action.payload });
    case reportsActions.GET_GENERAL_REPORT_SUMMARY_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_SHOP_GOCHI_TABLE_SUCCESS:
      return Object.assign({}, state, { shopGochiTableData: action.payload });
    case reportsActions.GET_REPORT_SHOP_GOCHI_TABLE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_SUMMARY_CUMULATIVE_SUCCESS:
      return Object.assign({}, state, {
        summaryCumulativeData: action.payload
      });
    case reportsActions.GET_REPORT_SUMMARY_CUMULATIVE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_SUMMARY_CUSTOM_SUCCESS:
      return Object.assign({}, state, { summaryCustomData: action.payload });
    case reportsActions.GET_REPORT_SUMMARY_CUSTOM_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_FILTERED_REPORT_SUMMARY_SUCCESS:
      return Object.assign({}, state, { summaryFilteredData: action.payload });
    case reportsActions.GET_FILTERED_REPORT_SUMMARY_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_GOCHI_AMOUNTS_PLATFORM_SUCCESS:
      return Object.assign({}, state, {
        gochiAmountPratformData: action.payload
      });
    case reportsActions.GET_REPORT_GOCHI_AMOUNTS_PLATFORM_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_GOCHI_AMOUNTS_TYPE_SUCCESS:
      return Object.assign({}, state, { gochiAmountTypeData: action.payload });
    case reportsActions.GET_REPORT_GOCHI_AMOUNTS_TYPE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_GOCHI_USER_COUNTS_SUCCESS:
      return Object.assign({}, state, { gochiUserCountData: action.payload });
    case reportsActions.GET_REPORT_GOCHI_USER_COUNTS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_GOCHI_COUNTS_SUCCESS:
      return Object.assign({}, state, { gochiCountData: action.payload });
    case reportsActions.GET_REPORT_GOCHI_COUNTS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case reportsActions.GET_REPORT_SHOP_GOCHI_AMOUNTS_SUCCESS:
      return Object.assign({}, state, { shopGochiAmountData: action.payload });
    case reportsActions.GET_REPORT_SHOP_GOCHI_AMOUNTS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default reports;
